import {HttpResponse} from '@angular/common/http';
import {Component, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DeviceAccessService} from '@balrog/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {DeviceAccess} from './device-access.model';

@Injectable()
export class DeviceAccessPopupService {
    private ngbModalRef: NgbModalRef;

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private deviceAccessService: DeviceAccessService

    ) {
        this.ngbModalRef = null;
    }

    open(component: Component, id?: number | any): Promise<NgbModalRef> {
        return new Promise<NgbModalRef>((resolve, reject) => {
            const isOpen = this.ngbModalRef !== null;
            if (isOpen) {
                resolve(this.ngbModalRef);
            }

            if (id) {
                this.deviceAccessService.find(id).subscribe((res: HttpResponse<DeviceAccess>) => {
                    this.ngbModalRef = this.deviceAccessModalRef(component, res.body);
                    resolve(this.ngbModalRef);
                });
            } else {
                // setTimeout used as a workaround for getting ExpressionChangedAfterItHasBeenCheckedError
                setTimeout(() => {
                    this.ngbModalRef = this.deviceAccessModalRef(component, new DeviceAccess());
                    resolve(this.ngbModalRef);
                }, 0);
            }
        });
    }

    deviceAccessModalRef(component: Component, deviceAccess: DeviceAccess): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.deviceAccess = deviceAccess;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true, queryParamsHandling: 'merge' });
            this.ngbModalRef = null;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true, queryParamsHandling: 'merge' });
            this.ngbModalRef = null;
        });
        return modalRef;
    }
}
